import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import FavouriteJourneyViewModel from "@/models/FavouriteJourneyViewModel";
import { ref } from "@vue/composition-api";

export default function () {
    const favouriteJourneys = ref<Array<FavouriteJourneyViewModel>>([]);

    const getFavouriteJourneys = async () => {
        await defineHeaderAxios();
        Axios.get("/api/favouriteJourney")
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    favouriteJourneys.value = result.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    getFavouriteJourneys();
    return {
        favouriteJourneys,
        getFavouriteJourneys,
    };
}
